module.exports = __webpack_public_path__ + "static/puas_1-3-fcd1e8fd490204debd24203daa0c329a.png";